import { usePostgresChangesRealtime } from './usePostgresChangesRealtime';

type Options = {
  enabled?: boolean;
  /** Optional project filter for editor: `id=eq.…` / `project_id=eq.…`. */
  projectId?: string;
  onChange?: () => void;
};

/**
 * Live-refresh Design catalogues list (and optional single project).
 * Requires migration 268.
 */
export function useDesignCatalogueRealtime(options: Options = {}) {
  const { enabled = true, projectId, onChange } = options;

  usePostgresChangesRealtime({
    enabled,
    channelName: projectId ? `design-catalogue-live:${projectId}` : 'design-catalogue-live',
    portalKind: 'crm',
    debounceMs: 500,
    onChange,
    listens: projectId
      ? [
          {
            schema: 'crm',
            table: 'design_catalogue_projects',
            filter: `id=eq.${projectId}`,
          },
          {
            schema: 'crm',
            table: 'design_catalogue_items',
            filter: `project_id=eq.${projectId}`,
          },
        ]
      : [
          { schema: 'crm', table: 'design_catalogue_projects' },
          { schema: 'crm', table: 'design_catalogue_items' },
        ],
  });
}
